import { all, call, put, takeEvery } from 'redux-saga/effects'
import { globalLoaderText } from "redux/CommonDashboard/actions";
import AssetInventoryAPiService from './AssetInventoryAPiService';
import { setAuditDatesList, setAuditCreationSuccess, setAuditUpdationSuccess, setAuditDeletionSuccess} from 'Store/AssetInventory/AuditDates/AuditDatesAction';
import { GET_AUDIT_DATES_LIST, CREATE_AUDIT, UPDATE_AUDIT, DELETE_AUDIT } from 'Store/AssetInventory/AuditDates/AuditDatesTypes';
import { API_URL, apiMethod, apiType } from 'utils';
import { IPayload } from 'Model/IPayload';

function* getAuditDatesList(): any {
    try {
        yield put(globalLoaderText("Fetching Audits...."));
        let payloadData : IPayload = {
            apiType : apiType.AssetManagement,
            endpoint : `auditcycle/getAuditSettings`,
            apiMethod :  apiMethod.GET,
            payload : null
        }
        const response = yield call(
            AssetInventoryAPiService.post,
            API_URL.PostWebApp, payloadData
            );

        if (response) {
            yield put(globalLoaderText(""));
            yield put(setAuditDatesList(response))
        } else {
            yield put(setAuditDatesList([]))
            yield put(globalLoaderText(""));
        }
    } catch (error) {
        yield put(globalLoaderText(""));
    }
}

function* CreateAuditDate(req: any): any {
    try {
        yield put(globalLoaderText("Creating Audit...."));
        let payloadData : IPayload = {
            apiType : apiType.AssetManagement,
            endpoint : `auditcycle/saveAuditSettings`,
            apiMethod :  apiMethod.POST,
            payload : req.audit
        }
        const response = yield call(
            AssetInventoryAPiService.post,
            API_URL.PostWebApp, payloadData
            );

        if (response) {
            yield put(globalLoaderText(""));
            yield put(setAuditCreationSuccess(response))
        } else {
            yield put(setAuditCreationSuccess({validationMessage: "Error occured while Saving the Audit.", isValid: false}));
            yield put(globalLoaderText(""));
        }
    } catch (error) {
        yield put(globalLoaderText(""));
    }
}

function* UpdateAuditDate(req: any): any {
    try {
        yield put(globalLoaderText("Updating Audit...."));
        let payloadData : IPayload = {
            apiType : apiType.AssetManagement,
            endpoint : `auditcycle/updateAuditSettings`,
            apiMethod :  apiMethod.POST,
            payload : req.audit
        }
        const response = yield call(
            AssetInventoryAPiService.post,
            API_URL.PostWebApp, payloadData
            );

        if (response) {
            yield put(globalLoaderText(""));
            yield put(setAuditUpdationSuccess(response))
        } else {
            yield put(setAuditUpdationSuccess({validationMessage: "Error occured while Updating the Audit.", isValid: false}))
            yield put(globalLoaderText(""));
        }
    } catch (error) {
        yield put(globalLoaderText(""));
    }
}

function* DeleteAuditDate(req: any): any {
    try {
        yield put(globalLoaderText("Deleting Audit...."));
        let payloadData : IPayload = {
            apiType : apiType.AssetManagement,
            endpoint : `auditcycle/deleteauditsettings`,
            apiMethod :  apiMethod.POST,
            payload : req.audit
        }
        const response = yield call(
            AssetInventoryAPiService.post,
            API_URL.PostWebApp, payloadData
            );

        if (response) {
            yield put(globalLoaderText(""));
            yield put(setAuditDeletionSuccess("success"))
        } else {
            yield put(setAuditDeletionSuccess("failed"))
            yield put(globalLoaderText(""));
        }
    } catch (error) {
        yield put(globalLoaderText(""));
    }
}

function* watchGetAllAudits() {
    yield takeEvery(GET_AUDIT_DATES_LIST, getAuditDatesList)
    yield takeEvery(CREATE_AUDIT, CreateAuditDate)
    yield takeEvery(UPDATE_AUDIT, UpdateAuditDate)
    yield takeEvery(DELETE_AUDIT, DeleteAuditDate)
}

export default function* combinedSaga() {
    yield all([
        watchGetAllAudits()
    ])
}